import api from './api';
import { Coupon, CreateCouponRequest, UpdateCouponRequest } from '../interfaces/Coupon';

export const couponService = {
  async getAll(): Promise<Coupon[]> {
    const response = await api.get('/coupons');
    return response.data;
  },

  async getById(id: string): Promise<Coupon> {
    const response = await api.get(`/coupons/${id}`);
    return response.data;
  },

  async create(data: CreateCouponRequest): Promise<Coupon> {
    const response = await api.post('/coupons', data);
    return response.data;
  },

  async update(id: string, data: UpdateCouponRequest): Promise<Coupon> {
    const response = await api.patch(`/coupons/${id}`, data);
    return response.data;
  },

  async deactivate(id: string): Promise<Coupon> {
    const response = await api.patch(`/coupons/${id}/deactivate`);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/coupons/${id}`);
  },
};
